export default __webpack_public_path__ + "static/media/posImg.6609332b.svg";